import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function KeyCreated({
  secretKey,
  handleCopy,
  copied,
  onCancel,
}: {
  secretKey: string;
  handleCopy: () => void;
  copied: boolean;
  onCancel: () => void;
}) {
  return (
    <div className="container-element">
      <div className="d-flex justify-content-start align-items-center mb-4">
        <div className="d-flex align-items-center gap-3">
          <FontAwesomeIcon icon={faArrowLeft} onClick={onCancel} />
          <h3 className="mb-0">Create New Key</h3>
        </div>
      </div>

      <p className="fw-bold">
        Make sure to copy your secret key now. You won't be able to see it again.
      </p>
      <div className="d-flex justify-content-between align-items-center">
        <code className="mb-0">{secretKey}</code>
        <button className="btn btn-outline-secondary" onClick={handleCopy}>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </div>
  );
}
